import api from './request';

/**
 * Get order history
 */
export const getHistoryRequest = (ids) => {
  let url = typeof ids !== 'undefined' && ids.length > 0 ? "history?location_id=" + ids : 'history';

  return api
    .request(url)
    .get();
};
